<template>
  <div id="app">
    <div class="level">
      <span>{{ fightData.groupDesc }}</span>
    </div>
    <div class="scoring">
      <div class="bg unselectable" @click.stop="startCountDown" @dblclick="addCountDown"
        @contextmenu.prevent="subtractCountDown">
        {{ countDown }}
      </div>
      <div class="more"> 【{{ userInfo.more }}号场】 </div>
      <div class="games unselectable" @dblclick="showScorepc">
        <span v-if="allFinished">本场地结束</span>
        <span v-else-if="fightData && fightData.matchNo">第{{ fightData.matchNo }}场</span>
      </div>
    </div>
    <div class="half-left">
      <div class="team">
        <div class="score unselectable" @click="addScore('l')" @contextmenu.prevent="subtractScore('l')">
          {{ leftScore.score }}
        </div>
        <div class="illegality unselectable" @click="illegality('l')" @contextmenu.prevent="subtractIllegality('l')">
          {{ leftScore.illegality }}
        </div>
        <div class="belt">
          <div class="belt-gray" :style="{
            backgroundColor: beltColorStyle.backgroundColor1,
            width: '70%'
          }"></div>
          <div class="belt-gray" :style="{
            width: '20%',
            backgroundColor: beltColorStyle.backgroundColor2
          }"></div>
          <div class="belt-gray" :style="{
            backgroundColor: beltColorStyle.backgroundColor1,
            width: '10%'
          }"></div>
        </div>
        <div class="top">
          <!-- <img class="team-logo" src="../src/assets/team-logo-default.jpg" /> -->
          <div class="right">
            <div class="figterNameA">
              {{ fightData.fighterAName }}
            </div>
            <div class="teamName">{{ fightData.teamAName }}</div>
          </div>
        </div>
        <!-- <div class="country-div">
          <img class="country" src="../src/assets/team-logo-default.jpg" />
          <span>{{ fightData.countryA }}</span>
        </div> -->
      </div>
    </div>
    <div class="half-right">
      <div class="team team-right">
        <div class="score unselectable" @click="addScore('r')" @contextmenu.prevent="subtractScore('r')">
          {{ rightScore.score }}
        </div>
        <div class="illegality unselectable" @click="illegality('r')" @contextmenu.prevent="subtractIllegality('r')">
          {{ rightScore.illegality }}
        </div>
        <div class="belt">
          <div class="belt-y"></div>
          <div class="belt-g"></div>
          <div class="belt-y"></div>
          <div class="belt-g"></div>
        </div>
        <div class="top">
          <div class="right" style="margin-right: 10px">
            <div class="figterNameB">
              {{ fightData.fighterBName }}
            </div>
            <div class="teamName">{{ fightData.teamBName }}</div>
          </div>
          <!-- <img
            class="team-logo"
            style="margin-right: 0px"
            src="../src/assets/team-logo-default.jpg"
          /> -->
        </div>
        <!-- <div class="country-div">
          <span style="margin-right: 10px">{{ fightData.countryB }}</span>
          <img
            class="country"
            style="margin-right: 0px"
            src="../src/assets/team-logo-default.jpg"
          />
        </div> -->
      </div>
    </div>
    <el-dialog title="上传赛果" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-radio-group v-model="form.winner_is_a">
        <el-radio :label="true">{{ fightData.fighterAName }}</el-radio>
        <el-radio :label="false">{{ fightData.fighterBName }}</el-radio>
      </el-radio-group>
      <div style="margin-top: 20px">
        <el-select v-model="form.win_con" placeholder="请选择获胜方式">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="scorepc" :disabled="isSubmitting">{{ isSubmitting ? '提交中...' : ' 提交 '
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import service from "../src/util/request";
export default {
  name: "App",
  data() {
    return {
      dialogVisible: false,
      allFinished: false,
      userInfo: {},
      fightData: {},
      leftScore: {
        score: 0,
        illegality: 0,
      },
      rightScore: {
        score: 0,
        illegality: 0,
      },
      form: {},
      second: 0,
      countDown: "00:00",
      interval: null,
      isCountDown: false,
      beltColorStyle: {},

      options: [
        { value: 1, label: "【常用】比分获胜", },
        { value: 3, label: "【常用】降服", },
        { value: 4, label: "对方取消资格", },
        { value: 5, label: "突然死亡(加时)", },
        { value: 6, label: "对方无法继续(加时)", },
        { value: 2, label: "一人组赛程结束", },
        { value: 7, label: "对方丧失意识", },
        { value: 8, label: "裁判判定(双伤)", },
      ],
      isSubmitting: false //提交状态锁，避免重复提交。
    };
  },
  mounted() {
    this.showLogin();
  },
  methods: {
    computedColor() {
      if (this.fightData.groupDesc.includes("蓝带")) { //成人
        this.beltColorStyle.backgroundColor1 = "#0573fd";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("紫带")) {
        this.beltColorStyle.backgroundColor1 = "#9d09de";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("棕带")) {
        this.beltColorStyle.backgroundColor1 = "#a35610";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("黑带")) {
        this.beltColorStyle.backgroundColor1 = "#222222";
        this.beltColorStyle.backgroundColor2 = "#fd0100";
      } else if (this.fightData.groupDesc.includes("灰带")) { //幼儿
        this.beltColorStyle.backgroundColor1 = "#888888";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("黄带")) {
        this.beltColorStyle.backgroundColor1 = "#ffff00";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("橙带")) {
        this.beltColorStyle.backgroundColor1 = "#fd8001";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else if (this.fightData.groupDesc.includes("绿带")) {
        this.beltColorStyle.backgroundColor1 = "#008102";
        this.beltColorStyle.backgroundColor2 = "#222222";
      } else {
        this.beltColorStyle.backgroundColor1 = "#ffffff";
        this.beltColorStyle.backgroundColor2 = "#222222";
      }
    },
    showLogin() {
      this.$prompt("请输入登录凭证:", "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          this.login(value);
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    showScorepc() {
      this.dialogVisible = true;
    },
    // 提交比赛结果。
    scorepc() {
      if (this.form.win_con == null) {
        alert("请选择获胜方式");
        return;
      }

      // 防止重复提交
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      // 发送请求
      service
        .post("scorepc", {
          match_id: this.fightData.matchID,
          winner_is_a: this.form.winner_is_a,
          token: localStorage.getItem("token"),
          win_con: this.form.win_con,
          a_score:
            parseInt(this.leftScore.score) +
            parseInt(this.leftScore.illegality),
          b_score:
            parseInt(this.rightScore.score) +
            parseInt(this.rightScore.illegality),
        })
        .then((res) => {
          if (res) {
            this.dialogVisible = false;
            this.currentMatch();
            this.form = {};
          }
        })
        .finally(() => {
          this.isSubmitting = false; // 无论成功失败都解锁提交状态
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    subtractCountDown() {
      this.second -= 1000;
      const minutes =
        Math.floor(this.second / 60 / 1000) <= 0
          ? "0" + Math.floor(this.second / 60 / 1000)
          : Math.floor(this.second / 60 / 1000);
      const seconds =
        Math.floor((this.second % (60 * 1000)) / 1000) < 10
          ? "0" + Math.floor((this.second % (60 * 1000)) / 1000)
          : Math.floor((this.second % (60 * 1000)) / 1000);

      // 输出或显示倒计时
      this.countDown = `${minutes}:${seconds}`;
    },
    addCountDown() {
      this.second += 10 * 1000;
      const minutes =
        Math.floor(this.second / 60 / 1000) <= 0
          ? "0" + Math.floor(this.second / 60 / 1000)
          : Math.floor(this.second / 60 / 1000);
      const seconds =
        Math.floor((this.second % (60 * 1000)) / 1000) < 10
          ? "0" + Math.floor((this.second % (60 * 1000)) / 1000)
          : Math.floor((this.second % (60 * 1000)) / 1000);

      // 输出或显示倒计时
      this.countDown = `${minutes}:${seconds}`;
    },
    stopCountDown() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    // 开始倒计时
    startCountDown() {
      if (!this.isCountDown) {
        this.countDownTimer();
      } else {
        this.stopCountDown();
      }
      this.isCountDown = !this.isCountDown;
    },
    // 倒计时
    countDownTimer() {
      let that = this;
      // 更新倒计时函数
      function updateCountdown(timeLeft) {
        const minutes =
          Math.floor(timeLeft / 60 / 1000) <= 0
            ? "0" + Math.floor(timeLeft / 60 / 1000)
            : Math.floor(timeLeft / 60 / 1000);
        const seconds =
          Math.floor((timeLeft % (60 * 1000)) / 1000) < 10
            ? "0" + Math.floor((timeLeft % (60 * 1000)) / 1000)
            : Math.floor((timeLeft % (60 * 1000)) / 1000);

        // 输出或显示倒计时
        console.log(`${minutes}:${seconds}`);
        that.countDown = `${minutes}:${seconds}`;
        if (!that.isCountDown) {
          return;
        }
        // 如果倒计时结束，清除interval
        if (timeLeft <= 0) {
          console.log("清除倒计时1");

          clearInterval(that.interval);
        }
      }
      // 开始倒计时
      that.interval = setInterval(() => {
        const distance = that.second - 1000; // 修正时区差

        that.second -= 1000;
        // 如果倒计时已经结束，清除interval
        if (distance < 0) {
          console.log("清除倒计时2");

          clearInterval(that.interval);
          return;
        }

        // 更新倒计时
        updateCountdown(distance);
      }, 1000);
      // 初始倒计时显示
      updateCountdown(that.second);
    },
    // 加载新的一局
    currentMatch() {
      service
        .post("current_match", { place: Number(this.userInfo.more) })
        .then((res) => {
          if (res.msg != "ok") {
            this.allFinished = true;
            return;
          }


          this.leftScore = {
            score: 0,
            illegality: 0,
          };
          this.rightScore = {
            score: 0,
            illegality: 0,
          };
          if (res.second) {
            this.fightData = res;
            this.second = res.second * 60 * 1000;
            const minutes =
              Math.floor(this.second / 60 / 1000) <= 0
                ? "0" + Math.floor(this.second / 60 / 1000)
                : Math.floor(this.second / 60 / 1000);
            const seconds =
              Math.floor((this.second % (60 * 1000)) / 1000) < 10
                ? "0" + Math.floor((this.second % (60 * 1000)) / 1000)
                : Math.floor((this.second % (60 * 1000)) / 1000);

            // 输出或显示倒计时
            this.countDown = `${minutes}:${seconds}`;
          } else {
            this.countDown = "00:00";
          }

          this.computedColor();

          // this.second = 1 * 60 * 1000;
        });
    },
    // 登录
    login(tokenStr) {
      service.post("stafflogin", { token: tokenStr }).then((res) => {
        if (res.result == 1) {
          this.userInfo = res;
          localStorage.setItem("userInfo", JSON.stringify(res));
          localStorage.setItem("token", tokenStr);
          this.currentMatch();
        } else {
          this.showLogin();
        }
      });
    },
    addScore(option) {
      if (option == "l") {
        this.leftScore.score++;
      } else {
        this.rightScore.score++;
      }
    },
    subtractScore(option) {
      if (option == "l") {
        this.leftScore.score > 0 ? this.leftScore.score-- : "";
      } else {
        this.rightScore.score > 0 ? this.rightScore.score-- : "";
      }
    },
    illegality(option) {
      if (option == "l") {
        this.leftScore.illegality--;
      } else {
        this.rightScore.illegality--;
      }
    },
    subtractIllegality(option) {
      if (option == "l") {
        this.leftScore.illegality < 0 ? this.leftScore.illegality++ : "";
      } else {
        this.rightScore.illegality < 0 ? this.rightScore.illegality++ : "";
      }
    },
  },
};
</script>

<style>
@import "../src/assets/font.css";
@import "../src/assets/app.css";
</style>
